var render = function render(){var _vm=this,_c=_vm._self._c;return _c('in-out-stock',{attrs:{"stock-type":"out"}})
}
var staticRenderFns = []

export { render, staticRenderFns }